import LdfFormEdit from '@features/creation/ldf/components/LdfFormEdit'
import { requirePermission } from '@lib/permissions/guards'
import { createFileRoute } from '@tanstack/react-router'
import { Pencil } from 'lucide-react'

export const Route = createFileRoute('/_app/creation/ldf/$id/edit')({
  loader: requirePermission('creation.ldf.edit'),
  staticData: {
    title: 'Modifier LDF',
    icon: Pencil,
    permission: 'creation.ldf.edit',
    section: 'Creation',
    showInBreadcrumb: true,
  },
  component: EditLdfPage,
})

function EditLdfPage() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier la LDF</h1>
      </div>
      <LdfFormEdit />
    </div>
  )
}